import { RouteObject } from "react-router-dom";
import { Login } from '@/features/auth/routes';
import { ROUTESPATH } from '../constant';
import Deactivated from "@/features/common/Deactivated";

export const publicRoutes: RouteObject[] = [
  {
    path: ROUTESPATH.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTESPATH.DEACTIVATED,
    element: <Deactivated />,
  },
];
